<template>
  <div class="d-flex flex-grow-1 align-center">
    <div
      v-if="hasLabel"
      class="mr-2 subtitle-2 font-weight-bold grey--text text--darken-2"
    >
      {{ label }}
    </div>
    <v-tooltip top :disabled="!hasTooltip">
      <template #activator="{ on, attrs }">
        <v-progress-linear
          v-bind="attrs"
          :color="color"
          :height="height"
          rounded
          :value="indeterminate ? null : value"
          :indeterminate="indeterminate"
          v-on="on"
        />
      </template>
      <span v-if="hasTooltip">{{ tooltip }}</span>
    </v-tooltip>
    <div v-if="hasAppendSlot" class="ml-2">
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    indeterminate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    color: {
      type: String,
      default: 'success',
    },
    height: {
      type: [String, Number],
      default: 18,
    },
    label: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasLabel() {
      return !!this.label;
    },
    hasAppendSlot() {
      return !!this.$slots.append;
    },
    hasTooltip() {
      return !!this.tooltip;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-progress-linear--rounded {
  border-radius: 10px;
}
</style>
